<template>
  <head>
    <title>
      {{ $t("CompanyNumbers") }}
    </title>
  </head>
  <div class="company-numbers-view">
    <AdminSidebar>
      <TableComponent
        :titles="titles"
        :data="data"
        :title="title"
        :pageUrl="pageUrl"
        deleteApi="api/delete_CompanyNumbers"
        EditUrl="/update-numbers"
      />
    </AdminSidebar>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";
import TableComponent from "@/components/AdminDashboard/TableComponent.vue";

export default {
  name: "company-numbers-view",
  data() {
    return {
      data: {},
      ErrorMessage: "",
      titles: [
        "id",
        "name_en",
        "name_ar",
        "description_en",
        "description_ar",
        "delete",
        "update",
        "show",
      ],
      title: "CompanyNumbers",
      pageUrl: "AddCompanyNumbers",
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_all_CompanyNumbers")
        .then((response) => {
          this.data = response.data;
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    AdminSidebar,
    TableComponent,
  },
};
</script>
